import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  /**
   * Polls a background process (e.g., translation), disables the trigger button, and shows a refresh button when done.
  * Usage:
   * - Wrap with `data-controller="refresh"
   * - a trigger button with `data-refresh-target="button"
   * - a hidden refresh button with `data-refresh-target="refresh"
   * - data-refresh-url-value="/path/to/status.json" (should return { ready: true/false })
   * - data-refresh-loading-label-value (text shown while polling)
   */ 

  static targets = ["button", "refresh"]

  static values = {
    url: String,
    pollingInterval: { type: Number, default: 10000 },
    loadingLabel: String
  }

  connect() {
    // You can trigger polling manually via: el.dispatchEvent(new Event("start-polling"))
    this.element.addEventListener("start-polling", () => this.startPolling())
  }

  startPolling() {
    this.disabledLoadingButton()

    this.polling = setInterval(() => {
      fetch(this.urlValue)
        .then(res => {
          return res.json()
        })
        .then(data => {
          if (data.ready) {
            clearInterval(this.polling)
            this.setDoneState()
          }
        })
        .catch(err => console.error("Polling error:", err))
    }, this.pollingIntervalValue)
  }

  disabledLoadingButton() {
    // Visually disables the polling button and shows a spinner
    const button = this.buttonTarget

    button.innerHTML = `<i class="far fa-spin fa-circle-notch"></i>&nbsp;${this.loadingLabelValue}`
    button.setAttribute("aria-disabled", "true")
    button.style.pointerEvents = "none"
    button.style.opacity = "0.5"
    button.style.cursor = "not-allowed"
  }

  setDoneState() {
    // When polling is complete: remove the button, show refresh link
    this.buttonTarget?.remove()
    this.showRefreshButton()
  }

  showRefreshButton() {
    if (this.hasRefreshTarget) {
      this.refreshTarget.classList.remove("hidden")
    }
  }
}
